import React from 'react';
const SearchBar = ({ searchQuery, setSearchQuery }) => {
    const onSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <form
            action="/"
            method="get"
            autoComplete="off"
            onSubmit={onSubmit}
        >
            <input
                value={searchQuery}
                onInput={(e) => setSearchQuery(e.target.value)}
                type="text"
                id="header-search"
                placeholder="검색어를 입력해주세요."
                name="s"
            />
            <button type="submit">검색</button>
        </form>
    );
};

export default SearchBar;